export default "__VITE_ASSET__BoItY6OA__"